import api from "../APIService";
const getEngineerProdTasks = async (id) => {
    return await api.getAllData(`/assignments?user.id=${id}&completed=false&pagination=false`)
}

export const TasksInProgressService = {
    getEngineerProdTasks,
}
